// src/layouts/AdminLayout.jsx
import { Link, Outlet } from 'react-router-dom';
import AssetsLoader from './AssetsLoader';

const SoftlandLayout = () => {

  return (
   
      <>

      <AssetsLoader
        styles={[
          'templates/softland/assets/img/favicon.png',
          'templates/softland/assets/img/apple-touch-icon.png',

          'https://fonts.googleapis.com',
          'https://fonts.gstatic.com',
          'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
          
          'templates/softland/assets/vendor/bootstrap/css/bootstrap.min.css',
          'templates/softland/assets/vendor/bootstrap-icons/bootstrap-icons.css',
          'templates/softland/assets/vendor/aos/aos.css',
          'templates/softland/assets/vendor/swiper/swiper-bundle.min.css',
          'templates/softland/assets/vendor/glightbox/css/glightbox.min.css',
          'templates/softland/assets/css/main.css',

        ]}
        scripts={[
          'templates/softland/assets/vendor/bootstrap/js/bootstrap.bundle.min.js',
          'templates/softland/assets/vendor/php-email-form/validate.js',
          'templates/softland/assets/vendor/aos/aos.js',
          'templates/softland/assets/vendor/swiper/swiper-bundle.min.js',
          'templates/softland/assets/vendor/glightbox/js/glightbox.min.js',
          'templates/softland/assets/js/main.js',
        ]}
      />

        <header id="header" className="header d-flex align-items-center fixed-top">
          <div className="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">

            <a href="index.html" className="logo d-flex align-items-center">
              {/* <!-- Uncomment the line below if you also wish to use an image logo --> */}
              {/* <!-- <img src="assets/img/logo.png" alt=""> --> */}
              <h1 className="sitename">Copy&Paste LLC</h1>
            </a>

            <nav id="navmenu" className="navmenu">
              <ul>
                <li><a href="#hero" className="active text-white">Home</a></li>
                <li><a href="#about" className="text-white">About</a></li>
                <li><a href="#features" className="text-white">Features</a></li>
                
                <li><a href="#contact" className="text-white" >Contact</a></li>
                <li><Link to="/login" className="text-white" >Login</Link></li>
              </ul>
              <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
            </nav>

          </div>
        </header>

        <Outlet />

        <footer id="footer" className="footer dark-background">
          <div className="container">
            <h3 className="sitename">Copy&Paste LLC</h3>
            <p>Sync messages across multiple devices seamlessly.</p>
            <div className="social-links d-flex justify-content-center">
              <a href=""><i className="bi bi-twitter-x"></i></a>
            </div>
            <div className="container">
              <div className="copyright">
                <span>Copyright</span> <strong className="px-1 sitename">Copy&Paste LLC</strong> <span>All Rights Reserved</span>
              </div>
            </div>
          </div>
        </footer>

        <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>


      </>
  );
};

export default SoftlandLayout;



